import { ResourceList } from "src/system/ResourceList.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import * as styles from "./AccountingPostingVacantPositionModuleList.style.ts";
import { Suspense, useState } from "react";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { replacePathParams } from "@exonn/utils";
import type { AccountingPostingPositionResource } from "@exonn/js-sdk/src/namespaces/accounting-posting";
import { useDataRouterContext } from "src/lib/react-router/useDataRouterContext.ts";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useTranslation } from "react-i18next";

export const AccountingPostingVacantPositionModuleList = () => {
  const [selectedRow, setSelectedRow] =
    useState<AccountingPostingPositionResource>();
  const { router } = useDataRouterContext();
  const { t } = useTranslation();
  return (
    <Suspense fallback={null}>
      <div css={styles.container}>
        <div css={styles.list}>
          <ResourceList
            onRowDoubleClick={(params) => {
              const route = createModuleRoutePaths({
                resource: ResourceEnum.AccountingPosting,
              });
              router.navigate(
                replacePathParams(route.edit.root, {
                  id: params.row.accounting_posting_id,
                }),
              );
            }}
            contextMenu={{
              selectedRow: selectedRow,
              onSelectedRowChange: setSelectedRow,
              items: [
                {
                  label: t("actions.edit", {
                    ns: TranslationNamespaceEnum.Common,
                  }),
                  icon: <i className={"icon-15-edit"} />,
                  key: "edit",
                  onSelect: (row: AccountingPostingPositionResource) => {
                    const route = createModuleRoutePaths({
                      resource: ResourceEnum.AccountingPosting,
                    });
                    router.navigate(
                      replacePathParams(route.edit.root, {
                        id: row.accounting_posting_id,
                      }),
                    );
                  },
                },
              ],
            }}
            hideToolbarCreateNewRecordButton
            resource={ResourceEnum.AccountingPostingVacantPosition}
          />
        </div>
      </div>
    </Suspense>
  );
};
